// extracted by mini-css-extract-plugin
export var dropdownButton = "_3r-0";
export var fullWidthDropdownButton = "_3r-1";
export var icon = "_3r-3";
export var iconPlaceholder = "_3r-2";
export var menuItemRow = "_3r-9";
export var separator = "_3r-e";
export var shortcutContainer = "_3r-7";
export var shortcutContainerFilled = "_3r-8";
export var shortcutIconLg = "_3r-6";
export var shortcutIconMd = "_3r-5";
export var shortcutIconSm = "_3r-4";
export var submenuChevron = "_3r-d";
export var submenuDropdown = "_3r-a";
export var submenuTriggerRow = "_3r-b";
export var submenuTriggerRowOpen = "_3r-c";